/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import PropTypes from "prop-types";
import InputCheckbox from "Components/input-checkbox";

const Desktop = ({
	isSelected, onSelected,
}) => (
	<>
		<InputCheckbox
			title="Show items on sale"
			isSelected={isSelected}
			onClick={onSelected}
		/>
	</>
);

Desktop.propTypes = {
	isSelected: PropTypes.bool.isRequired,
	onSelected: PropTypes.func.isRequired,
};

export default Desktop;
